import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UseChatGroupsRealtimeProps {
  userId: string | null;
  onChatGroupsChange: () => void;
}

export const useChatGroupsRealtime = ({ userId, onChatGroupsChange }: UseChatGroupsRealtimeProps) => {
  useEffect(() => {
    if (!userId) return;

    console.log('=== SETTING UP CHAT GROUPS REAL-TIME ===');
    console.log('User ID:', userId);

    // Subscribe to chat group changes
    const chatGroupsChannel = supabase
      .channel('chat-groups-realtime')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'chat_groups'
        },
        async (payload) => {
          console.log('=== NEW CHAT GROUP CREATED ===');
          console.log('New group:', payload.new);
          
          // Trigger refresh
          onChatGroupsChange();
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'chat_group_users'
        },
        async (payload) => {
          console.log('=== NEW CHAT GROUP MEMBER ADDED ===');
          console.log('New member:', payload.new);
          
          // If the current user was added to a group, reload groups
          if (payload.new.user_id === userId) {
            console.log('Current user was added to a new group, reloading groups');
            onChatGroupsChange();
          }
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'chat_groups'
        },
        async (payload) => {
          console.log('=== CHAT GROUP UPDATED ===');
          console.log('Updated group:', payload.new);
          onChatGroupsChange();
        }
      )
      .subscribe();

    return () => {
      console.log('Cleaning up chat groups real-time subscription');
      supabase.removeChannel(chatGroupsChannel);
    };
  }, [userId, onChatGroupsChange]);
};